import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';

const app = document.querySelector('.js-component-archive-app');
if (app) {
  ReactDOM.render(<App {...app.dataset}/>, app);
}



// WEBPACK FOOTER //
// ./src/index.js